import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { QuoteRequestDto } from "#modules/quoteRequests/infra/fetchQuoteRequest.api";
import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";
import { QuoteRequestFilesModal } from "#modules/quoteRequestsV2/view/organisms/QuoteRequestFilesModal";

type Props = {
  opened: boolean;
  onClose: () => void;
  quoteRequest: QuoteRequestDto;
};

export const ImportPartsModal = ({ opened, onClose, quoteRequest }: Props) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return (
    <QuoteRequestFilesModal
      opened={opened}
      onClose={onClose}
      title={t("quoteRequestV2.importPartsModal.title")}
      primaryText={t("quoteRequestV2.importPartsModal.next")}
      quoteRequestId={quoteRequest.id}
      showClientAndReferenceFields={false}
      onNext={() => queryClient.invalidateQueries(quoteRequestQuery(quoteRequest.id))}
    />
  );
};
